﻿import { type Translations } from "./fi-FI";
const LocaleEnUS: Translations = {
  HeaderInnofactorLogoAlt: 'Innofactor Signature logo',
  HeaderLogoutButtonAlt: 'Logout',
  HeaderInfoButtonAlt: 'Information about the service',

  Login: 'Login', 
  LoginHeader: 'Login',
  Logout: 'Logout',
  LogoutHeader: 'Logout',
  
  ScsAuthenticationDisplayName:  'Smart Card',
  EmailAuthenticationDisplayName:  'Email',
  LoginReasonDefault:  'Begin signing by logging in',
  LoginReasonAdditionalAuthRequired:  'Continue by selecting next authentication method',
  scsProcessResponseError:  'The card reader did not respond or reading was cancelled. Please make sure the card reader software is installed, it is running and your smart card is in the reader. You can use the \u003ca href=\'https://localhost:53952/\'\u003ecard reader info page\u003c/a\u003e to verify operation. If the info page cannot be accessed, the card reader software is not installed or it is not running.',
  scsProcessHandlingResponse:  'Response received from the card reader, handling it...',
  scsProcessWaitingForResponse:  'Waiting for response from the card reader... Please follow the card reader\u0027s instructions.',
  NoVisibleExternalProviders:  'No identification providers configured for this tenant.',
  InvalidLoginRequest:  'Invalid Login Request',
  LoginReasonInvalidScsResponse:  'Please make sure the card reader is installed, it is running and the smart card is in the reader',
  LoginReasonExpiredError:  'Login timed out',
  LoginReasonLoggedOut:  'You have been logged out and can close the browser. If you wish, you may login again.',
  LogoutInProgress: 'Logging out...',

  ScsLoginNotAllowed:  'Smart Card login is not allowed for this signature',
  EmailLoginNotAllowed: 'Email login is not allowed for this signature',
  SmsLoginNotAllowed: 'SMS login is not allowed for this signature',
  LoginReasonInvalidScsIssuerError:  'Unsupported smart card issuer',
  LoginReasonUnauthorizedError:  'You are not the right person to sign this document',
  LoginReasonInvalidScsResponseError:  'Problem with the card reader',
  LoginReasonExpired:  'Please login again',
  LoginReasonUnauthorized:  'You can try using other credentials when logging in',
  LoginReasonInvalidScsIssuer:  'You can try using other credentials when logging in',
  LoginReasonSigningTimeout:  'Login again to continue work on the document',
  LoginReasonErrorDuringLogin: 'An error occurred during login. Please try again',
  
  Otp_Email_Header: 'Authenticate with Email',
  Otp_Email_AuthenticationInfo: 'You will receive a code via email that you can use to authenticate. First enter the email address to which the signature invitation was sent.',
  Otp_Email_EnterUserIdentifier: "Email address",
  Otp_Email_SendCode: 'Send authentication code',
  Otp_Email_UserIdentifierInvalid: 'The email address you provided does not match the email address to which the signature invitation was sent. Enter the email address exactly and try again.',
  Otp_Email_CodeSent: 'The authentication email has been sent. Check your inbox and enter the authentication code from the email below. If you don\u0027t see the email, please wait a while. Also check your junk mail folder and junk mail settings.',
  Otp_Email_CannotSendCodeTooSoon: 'An authentication email has already been sent. Please check your inbox, including junk mail. You can send another authentication code after a while.',
  Otp_Email_EnterCode: 'Authentication code',
  Otp_Email_CodeInvalid : 'The code is not correct. Enter the code you received via email.',  
  Otp_Email_SubmitCode: 'Submit',

  Otp_Sms_Header: 'Authenticate with SMS',
  Otp_Sms_AuthenticationInfo: 'You will receive a code via SMS that you can authenticate with. First, enter the mobile phone number in international format (+358...), to which the signing request was sent.',
  Otp_Sms_EnterUserIdentifier: "Phone number",
  Otp_Sms_SendCode: 'Send authentication code',
  Otp_Sms_UserIdentifierInvalid: 'The phone number you provided does not match the phone number to which the signing request was sent. Enter the phone number exactly and try again.',
  Otp_Sms_CodeSent: 'The authentication code has been sent to your phone. Check your messages and enter the authentication code below. If the message does not arrive, wait a moment.',
  Otp_Sms_CannotSendCodeTooSoon: 'An authentication code has already been sent. Check your messages. You can send a new authentication code in a moment.',
  Otp_Sms_EnterCode: 'Authentication code',
  Otp_Sms_CodeInvalid : 'The authentication code is not correct. Enter the authentication code you received via SMS.',  
  Otp_Sms_SubmitCode: 'Submit',

  SkipToContent:  'Skip to content',
  LanguageSelection:  'Language selection',


  UnauthorizedErrorHeader: 'Error',
  UnauthorizedErrorMessage: 'You are not the right person to sign this document. The requester allows only a specific person to sign the document. If you are the right person, please ensure you are logged in with the correct credentials. If the problem persists, contact the requester.',

  Unauthorized: {
    IncorrectEmail: 'You are not the right person to sign this document. The requester allows only a specific person to sign the document. If you are the right person, please ensure you are logged in with the correct email address. If the problem persists, contact the requester.',
    IncorrectSsn: 'You are not the right person to sign this document. The requester allows only a specific person to sign the document. If you are the right person, please ensure you are logged in with the correct credentials. If the problem persists, contact the requester.',
    IncorrectPhone: 'You are not the right person to sign this document. The requester allows only a specific person to sign the document. If you are the right person, please ensure you are logged in with the correct phone number. If the problem persists, contact the requester.',
  },

  SignFlowNotFoundErrorMessage: 'This signature request could not be found. Check that you opened this link from the invitation email without modifying the link. The signature request can also have been deleted.',
  SignFlowCanceledErrorMessage: 'This signature request has been canceled ',
  SignFlowRejectedBySignerErrorMessage: 'This signature request has been aborted',
  IdentityServerErrorMessage: 'An error occurred',

  LoginPrompt: 'Start signing by logging in',
  Loading: 'Loading',
  UserName: 'Username',

  SignTabButtonText: 'Signature',
  AttachmentsTabButtonText: 'Attachments',

  Document: 'Document',
  AlreadySigned: 'This document has already been signed',
  FinalizedDocument: 'Electronically signed document',
  WaitingForFinalization_Signer: 'You have signed this document. You can view the signed document on this page once it has been processed. This page will update automatically once the document is processed. You can return to this page later using the signing link.',
  WaitingForFinalization_Approver: 'You have approved this document. You can view the signed document on this page once it has been processed. This page will update automatically once the document is processed. You can return to this page later using the approval link.',
  WaitingForOthers_Signer: 'You have signed this document. You can view the signed document on this page once other signers have signed. This page will update automatically once other signers have signed. You can return to this page later using the signing link.',
  WaitingForOthers_Approver: 'You have approved this document. You can view the signed document on this page once other signers have signed. This page will update automatically once other signers have signed. You can return to this page later using the approval link.',
  SignFlowValidatingTitle: 'Preparing document',
  SignFlowValidating: 'This document is being validated. This page will update automatically once the document is processed. You can return to this page later using the signing link.',
  DownloadUnsignedDocument: 'Download file to be signed',
  DownloadFinalizedDocument: 'Download file',
  DownloadFinalizedZip: 'Download document with attachments',
  RejectButtonText: 'Reject',
  BeginScsSigningButtonText: 'Start signing',
  SignButtonText: 'Sign',
  ApproveButtonText: 'Mark as approved',
  Attachments: 'Attachments',
  NoAttachments: 'No attachments',
  Attachment: 'Attachment',
  OpenAttachment: 'Open attachment: $',
  Close: 'Close',
  
  SigningInfoHeader: 'Electronic signature',
  SigningInfoSubHeader1: 'The following information about you will be saved when signed',
  SigningInfoSubHeader2Signers: 'Signers',
  SigningInfoSubHeader2Viewers: 'Viewers',
  SigningInfoSubHeader3Approvers: 'Approvers',
  SigningInfoSubHeader3: 'Signature request details',
  SigningInfoName: 'Name',
  SigningInfoFinnishSSN: 'Social security number',
  SigningInfoOrganisation: 'Organisation',
  SigningInfoRole: 'Role',
  SigningInfoNoName: 'No name',
  SigningInfoOpenSignTab: 'Open document',
  SigningInfoInviterName: 'Requester’s name',
  SigningInfoInviterEmail: 'Requester’s email',
  SigningInfoInvitationMessage: 'Invitation message',
  SigningInfoSignflowName: 'Document name',
  SigningInfoStatusPending_Approver: 'Approve pending',
  SigningInfoStatusDone_Approver: 'Approved',
  SigningInfoStatusPending_Signer: 'Sign pending',
  SigningInfoStatusDone_Signer: 'Signed',
  SigningInfoRejected: 'Rejected',
  InfoPageUrl: 'Information about the service and data usage',

  SignDialogHeader: 'Sign',
  SignDialogText1: 'Sign the document?',
  SignDialogText2: 'The following information about you will be saved in the document:',
  SignDialogField_Name: 'Name',
  SignDialogField_Procuration: 'Select your signing right',
  SignDialogField_ProcurationRepresentative: 'Representative',
  SignDialogField_ProcurationAuthority: 'Authority to sign',
  SignDialogField_ProcurationOther: 'Other right to sign',
  SignDialogCancelButtonText: 'Cancel',
  SignDialogFinishScsButtonText: 'Sign',
  SignDialogSignButtonText: 'Sign',

  ApproveDialogHeader: 'Approval',
  ApproveDialogText1: 'Approve the document?',
  ApproveDialogText2: 'The following information about you will be saved in the document:',
  ApproveDialogField_Name: 'Name',
  ApproveDialogCancelButtonText: 'Cancel',
  ApproveDialogFinishScsButtonText: 'Mark as approved',
  ApproveDialogSignButtonText: 'Mark as approved',

  ZipDialogHeader: 'File compression in progress',
  ZipDialogContent: 'The zip package of signed files is still being prepared, this may take a while. Please try again later.',
  ZipDialogClose: 'Ok',

  UserIdentifierType_FinnishSSN: "Social security number",
  UserIdentifierType_SwedishSSN: "Personal identity number",
  UserIdentifierType_NorwegianSSN: "National identity number",
  UserIdentifierType_FinnishAuthenticatorIdentifier: "Finnish Authenticator identifier",
  UserIdentifierType_FinnishElectronicIdentificationNumber: "Electronic Unique Identification Number (SATU)",
  UserIdentifierType_MitIdUuid: "MitID UUID",
  UserIdentifierType_Scs: "Smart card identification details",
  UserIdentifierType_EidasPersonalIdentifier: "eIDAS Identifier",
  UserIdentifierType_Email: "Email address",
  UserIdentifierType_NationalSSN: "Social security number",
  UserIdentifierType_PhoneNumber: "Phone number",

  RejectDialogHeader: 'Reject',
  RejectDialogRejectionComment: 'Rejection reason',
  RejectDialogCancelButtonText: 'Cancel',
  RejectDialogRejectButtonText: 'Reject',

  SigningTimedOutText: 'Login again to continue work on the document.',

  SigningInProgressDialogHeader: 'Signing',
  SigningInProgressDialogText: 'The document is being signed...',

  SignedDialogHeader: 'Signed',
  SignedDialogText: 'The document has been signed',

  RejectionInProgressDialogHeader: 'Rejecting',
  RejectionInProgressDialogText: 'The document is being rejected',

  RejectedDialogHeader: 'Rejected',
  RejectedDialogText: 'The document has been rejected',

  SigningFailedDialogHeader: 'Signing failed',
  RejectionFailedDialogHeader: 'Rejecting failed',

  InfoPageHeading: 'Information About the Service',
  InfoPage: [
    { link: 'https://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32014R0910', 
      p: 'This service, Innofactor Signature, provides electronic signature capabilities. Signatures can be advanced or qualified electronic signatures, as defined in the $eIDAS regulation$.' },
    { heading1: 'Use of personal information' },
    { p: 'The signer\'s name and unique identification information are stored in the signed document during the signing process. Unique identification can be, for example, a social security number, Electronic Unique Identification Number (SATU), Smart Card identification details, or the signer\'s email address. When signing the document, the signer will see what information is saved.' },
    { p: 'This information is required for the signatures to be valid advanced or qualified signatures.' },
    { p: 'The requester of the signature will see the signers\' information.' },
    { p: 'Signers will be able to see all signers\' names after the signing process is completed. Signers will not see the unique identification information.' },
    { p: 'Information related to a signature is stored in the signature service while the signing process is active. After the signing process becomes inactive, the information is deleted from the signature service.' }
  ],
  
  PrivacyPolicy: 'Privacy Policy',
  OpenPrivacyPolicy: 'Open Privacy Policy',

  InfoPageFeedbackUrlHeader: 'Feedback',
  OpenInfoPageFeedbackUrl: 'Open Feedback Form',

  Error: 'Error',
  LoginErrorDescription: 'An error occurred during login. Please try again $here$.',

  ManualPage: [
    { heading1: 'Manual' },
    { p: 'This manual covers the basics of electronic signing. Images shown are examples and may differ from what you see.' },
    { heading2: 'Accessing the Signature Service' },
    { p: 'Open the signature service from the link in the invitation email you received.' },
    { heading2: 'Authentication' },
    { p: 'Authenticate to the signature service by selecting an authentication method from the available options.' },
    { img: 'auth_eng', alt: 'Authenticating' },
    { heading2: 'Signing View' },
    { p: 'After authentication succeeds, you can review the document to be signed and its attachments.' },
    { p: 'From the bottom of the screen, you can either reject or sign the document.' },
    { p: 'You can return to the signing view later by opening the link from your invitation email again.' },
    { img: 'preview_eng', alt: 'Signing view' },
    { heading2: 'Signing' },
    { p: 'Sign the document with the Sign button. You can confirm the signature in the confirmation dialog or cancel.' },
    { img: 'dialog_eng', alt: 'Signing' },
    { p: 'After all participants have signed the document, an electronically signed version will be displayed, and signers\' details can be seen on the cover page. After this, you can also download the electronically signed version.' },
    { heading2: 'Rejecting a Signature' },
    { p: 'A signature can also be rejected by providing a rejection reason in the confirmation dialog.' },
    { img: 'reject_eng', alt: 'Rejecting signature' },
    { heading2: 'Logging Out' },
    { p: 'You can log out from the signature service using the door icon in the top-right corner of the screen.' },
    { img: 'logout', alt: 'Logging out' },
  ],
  
  AccessibilityPageHeading: 'Accessibility statement',
  OpenAccessibilityStatement: 'Open accessibility statement',

  AccessibilityPage: [
    { heading1: 'Accessibility statement' },
    { p: 'This page has not been translated yet. Please choose another language.' },
  ],

  LoginError: {
    HeaderText: 'Login failed',
    DefaultReason: 'There was an error during login. You can try again by reopening the signature link. If the error persists, remove any browser extensions or try using a different browser. Also, make sure that cookies are allowed. If the problem is not resolved, contact the requester of the signature.',
  }
}
export default LocaleEnUS;
